import { SvgIcon } from "@mui/material";
import React from "react";

export default function ScheduleIcon({ ...props }) {
  return (
    <SvgIcon
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M20 6.42871C20 5.87643 19.5523 5.42871 19 5.42871H5C4.44772 5.42871 4 5.87643 4 6.42871V20.4287C4 20.981 4.44772 21.4287 5 21.4287H19C19.5523 21.4287 20 20.981 20 20.4287V6.42871ZM22 20.4287C22 22.0856 20.6569 23.4287 19 23.4287H5C3.34315 23.4287 2 22.0856 2 20.4287V6.42871C2 4.77186 3.34315 3.42871 5 3.42871H19C20.6569 3.42871 22 4.77186 22 6.42871V20.4287Z"
          fill="#6A7282"
        />
        <path
          d="M15 6.42871V2.42871C15 1.87643 15.4477 1.42871 16 1.42871C16.5523 1.42871 17 1.87643 17 2.42871V6.42871C17 6.981 16.5523 7.42871 16 7.42871C15.4477 7.42871 15 6.981 15 6.42871Z"
          fill="#6A7282"
        />
        <path
          d="M7 6.42871V2.42871C7 1.87643 7.44772 1.42871 8 1.42871C8.55228 1.42871 9 1.87643 9 2.42871V6.42871C9 6.981 8.55228 7.42871 8 7.42871C7.44772 7.42871 7 6.981 7 6.42871Z"
          fill="#6A7282"
        />
        <path
          d="M21 9.42871C21.5523 9.42871 22 9.87643 22 10.4287C22 10.981 21.5523 11.4287 21 11.4287H3C2.44772 11.4287 2 10.981 2 10.4287C2 9.87643 2.44772 9.42871 3 9.42871H21Z"
          fill="#6A7282"
        />
      </svg>
    </SvgIcon>
  );
}
